import type { FeedItem } from '@/components/ActivityFeed/ActivityFeed';
import {
  extractChanges,
  fieldNameList,
} from '@/components/ActivityFeed/normalize';
import type { ContactComment, ContactEvent } from '@/models/contacts';

const LABELS: Record<string, string> = {
  firstName: 'First name',
  lastName: 'Last name',
  email: 'Email',
  phone: 'Phone',
  whatsapp: 'WhatsApp',
  telegram: 'Telegram',
  notes: 'Notes',
  referringAgentId: 'Referring agent',
};

export function buildContactFeed(
  events: ContactEvent[],
  comments: ContactComment[],
): FeedItem[] {
  const items: FeedItem[] = [];
  for (const e of events) {
    if (e.kind === 'commented') continue;
    const base = {
      id: `event-${e.id}`,
      at: e.createdAt,
      actor: e.actorName ?? e.actorEmail ?? null,
    };
    switch (e.kind) {
      case 'created':
        items.push({ ...base, kind: 'system', title: 'Created' });
        break;
      case 'field_updated': {
        const changes = extractChanges(e.payload, LABELS);
        items.push({
          ...base,
          kind: 'update',
          title: changes
            ? 'Updated'
            : `Updated ${fieldNameList(e.payload, LABELS)}`,
          changes,
        });
        break;
      }
      case 'owner_changed':
        items.push({ ...base, kind: 'system', title: 'Member changed' });
        break;
      case 'converted_from_lead':
        items.push({ ...base, kind: 'system', title: 'Converted from lead' });
        break;
      default:
        items.push({ ...base, kind: 'system', title: e.kind });
    }
  }
  for (const c of comments) {
    items.push({
      id: `comment-${c.id}`,
      at: c.createdAt,
      actor: c.authorEmail ?? 'System',
      kind: 'comment',
      title: 'Comment',
      body: c.body,
    });
  }
  return items;
}
